var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleStoreWhiteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85515 6.46582C9.62144 6.01573 12.0436 8.22852 12.0436 8.22852C14.3138 6.246 17.2331 6.46582 17.2331 6.46582C21.6307 6.52952 22.4124 9.36862 22.4216 9.40234C20.7558 10.6402 19.4139 12.6655 19.5387 15.2754C19.7257 19.1806 23.5749 21.1484 23.5749 21.1484C22.1613 25.0659 19.6375 27.9847 17.2331 28.1953C15.2906 28.3657 13.728 27.0125 12.6208 27.0205C11.5356 27.0295 10.5025 28.4989 8.00847 28.1953C6.06805 27.9591 0.957996 24.6442 0.513357 15.2754C0.244615 9.61364 4.08867 6.91598 6.85515 6.46582ZM18.2233 0C18.2233 0 18.6345 7.12872 11.6423 6.9834C11.6423 6.9834 11.019 1.32067 18.2233 0Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStoreWhiteIcon);
export default __webpack_public_path__ + "static/media/apple-store-white-icon.c3f30254cdb7adf9de9afeb6c0f80e36.svg";
export { ForwardRef as ReactComponent };